import { BANK_OPERATION_KIND, type BankOperationKind } from '@klopotun/domain';
import type { BankOperation } from '../../../entities/bank-transaction/index.js';

const NO_DESCRIPTION_TEXT = 'Без опису';

const UNCOUNTED_NOTE = { label: 'не враховано', tone: 'muted' } as const;

const REFUND_NOTE = { label: 'повернення', tone: 'muted' } as const;

const SUBSCRIPTION_NOTE = { label: 'підписка', tone: 'muted' } as const;

type OperationNote = typeof UNCOUNTED_NOTE | typeof REFUND_NOTE | typeof SUBSCRIPTION_NOTE;

type DescribedOperation = Pick<BankOperation, 'description'>;

type ConvertedOperation = Pick<BankOperation, 'currency' | 'baseAmountMinor'>;

export const operationDescriptionOf = (operation: DescribedOperation): string => {
  const description = operation.description.trim();

  return description === '' ? NO_DESCRIPTION_TEXT : description;
};

export const operationNoteOf = (operation: BankOperation): OperationNote | undefined => {
  if (operation.subscription !== null) {
    return SUBSCRIPTION_NOTE;
  }

  if (operation.baseAmountMinor === null) {
    return UNCOUNTED_NOTE;
  }

  return operation.kind === BANK_OPERATION_KIND.REFUND ? REFUND_NOTE : undefined;
};

export const convertedAmountMinorOf = (
  operation: ConvertedOperation,
  baseCurrency: string,
): number | null => {
  const isInBaseCurrency = operation.currency === baseCurrency;

  return isInBaseCurrency ? null : operation.baseAmountMinor;
};

export const operationKindTextOf = (kind: BankOperationKind): string => {
  if (kind === BANK_OPERATION_KIND.REFUND) {
    return 'Повернення';
  }

  if (kind === BANK_OPERATION_KIND.INCOME) {
    return 'Надходження';
  }

  if (kind === BANK_OPERATION_KIND.TRANSFER) {
    return 'Переказ між своїми рахунками';
  }

  return 'Витрата';
};
